// Copyright (c) 2016 Deere & Company

export const getSelectAllText = source => source.length ? 'DESELECT_ALL' : 'SELECT_ALL';

export const getDefaultPipStatuses = pipStatuses => pipStatuses.filter(value => value.key !== 'ZPTE');



// WEBPACK FOOTER //
// ./src/reports/shared/services/criteria.js